/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Icon } from '../../ui/Icon';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { ArrowDownStyles } from './index.styles';

class ArrowDown extends SafePureComponent {
  safeRender() {
    const { type } = this.props;
    return (
      <span css={ArrowDownStyles(type)}>
        <Icon
          customCss={{
            transform: 'rotate(-90deg)',
          }}
          name="arrow-left"
        />
      </span>
    );
  }
}

ArrowDown.displayName = 'ArrowDown';

export default ArrowDown;
